import { Injectable } from '@angular/core';
import { NAV_SECTIONS } from './nav.config';
import { NavigationSection } from './nav-model';
import { PermissionService } from '../../../core/services/permission/PermissionService';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  constructor(private permissionService: PermissionService) {}

  getNavigation(role: string): NavigationSection[] {
    const forRole = NAV_SECTIONS.map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.roles || item.roles.includes(role)),
    }));
    const rawSections =
      role === 'tenant_admin'
        ? forRole
        : forRole
            .map((section) => ({
              ...section,
              items: section.items.filter(
                (item) => !item.module || this.permissionService.hasModule(item.module),
              ),
            }))
            .filter((section) => section.items.length > 0);

    return rawSections.map((section) => {
      const reportIndex = section.items.findIndex(
        (item) => item.label?.toLowerCase() === 'reports',
      );
      if (reportIndex !== -1 && reportIndex !== section.items.length - 1) {
        const items = [...section.items];
        const [reportItem] = items.splice(reportIndex, 1);
        items.push(reportItem);
        return { ...section, items };
      }
      return section;
    });
  }
}
